import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { GetProductSalesRankingServiceRequestParams } from '@musinsa/services-curator';
import {
  getProductSalesRankingService,
  getSalesRankingAvailableYearMonthsService,
  getSalesRankingLastUpdatedAtService,
} from '@musinsa/services-curator';
import type { InfiniteQueryFnParams } from './types';

export const salesRankingFactory = createQueryKeys('salesRanking', {
  availableMonths: {
    queryKey: ['data'],
    queryFn: getSalesRankingAvailableYearMonthsService,
  },
  productSalesRanking: (params: GetProductSalesRankingServiceRequestParams) => ({
    queryKey: [{ params }],
    queryFn: ({ pageParam }: InfiniteQueryFnParams) =>
      getProductSalesRankingService({
        ...params,
        page: pageParam,
      }),
  }),
  lastUpdatedAt: {
    queryKey: null,
    queryFn: getSalesRankingLastUpdatedAtService,
  },
});
